import React from 'react';
import './SignUpButton.css';

const SignUpButton = ({ onClick, text }) => {
    return (
        <div style={{ left: 182 }} className={'signup-button-container'} onClick={() => onClick()} >
            {text}
        </div>
    )
}

export default SignUpButton;